import firebase from 'firebase/app'
import 'firebase/analytics'
import firebaseConfig from './firebase-config.json'

firebase.initializeApp(firebaseConfig)
const analytics = firebase.analytics()

export { analytics }
